import {defineMessages} from "react-intl";

export const main = defineMessages({
    title: { id: "seo-title-user-profile", defaultMessage: "Mon profil utilisateur" }
  });